<template>
  <q-page>
    <div class="q-ma-md render-container" v-html="renderedMd"></div>
  </q-page>
</template>

<script>
import { updateCustomMd } from '../../js/customMdParse/customMdParse'

export default {
  name: 'home',
  data () {
    return {
      content: `# Notes
Notes are built up of two important parts:
1. Content
2. User Data

## Content
Content is simply the markdown that describes the note. Content follows a custom form of markdown based on [marked](https://github.com/markedjs/marked).
By default it follows all of the rules of [marked](https://github.com/markedjs/marked)
but can be overridden by any <a href="/docs/components" onClick="event.preventDefault(); $ch.router.push('/docs/components')">components</a>
you have activated.  All notes which do not have a
<a href="/docs/note-templates" onClick="event.preventDefault(); $ch.router.push('/docs/note-templates')">note template</a>
applied to them are rendered in the preview tab.
#### TODO: fix this section
The content editor in Submind (based on the wonderful ace editor **add ref**) accepts ([marked](https://github.com/markedjs/marked)
flavoured markdown) and the rendered view is updated as you type.  If you're familiar with Github or **find more references using markdown**
then you'll feel right at home.  On top of regular markdown, Submind supports prebuilt or custom written Components **(Add link)**.


## User Data
User Data is information related to a note that should not be directly rendered.  User Data
is defined as JSON.  For example:
\`\`\`
{
  "data1": 123
}
\`\`\`
User Data is used by custom <a href="/docs/note-templates" onClick="event.preventDefault(); $ch.router.push('/docs/note-templates')">note templates</a>
 and by some <a href="/docs/components" onClick="event.preventDefault(); $ch.router.push('/docs/components')">components</a>.
The \`templateId\` field is also used to specify which <a href="/docs/note-templates" onClick="event.preventDefault(); $ch.router.push('/docs/note-templates')">note templates</a> should be applied to a note.

## Note Titles
If the first line of a note content starts with a *h1* heading then the
note will be named after that heading.  For example, the title of a note with the following
content would be *My Note*.
\`\`\`
# My Note
This is the body of my note.
\`\`\`
The title is used as the text for the note in the note tree.
`,
      renderedMd: '',
      componentDefinitionAry: []
    }
  },
  mounted () {
    this.renderedMd = updateCustomMd(this.content || '', this.componentDefinitionAry, this.item, null, false, this.saveThrottled) // eslint-disable-line vue/no-side-effects-in-computed-properties
    this.renderedMd = this.renderedMd + '<div style="width: 100%; height: 25vh;"></div>' // eslint-disable-line vue/no-side-effects-in-computed-properties
    // updateComponentHtmlInDOM()
  }
}
</script>

<style scoped>

</style>
